**Deprecated:** Use `positionProfiles` instead. Retained for integrations that only support a single position profile.
